<template>
<div class="form-group">
  <label class="control-label">NIS</label>
  <input
    @input="$emit('input', $event.target.value)"
    :value="value | onlyNumbersMask"
    :required="project.requiredNIS"
    v-validate="modelValidations.additionalData.nis"
    maxlength="11"
    autocomplete="off"
    class="form-control"
    type="text"
    name="nis"
  >
  <small
    v-if="!nisValidation.validate(value)"
    class="text-danger"
  > O NIS informado não é válido
  </small>
</div>
</template>

<script>
import {nisService} from '../../../services/validations'
import {mapGetters} from 'vuex'

export default {
  name: 'InputNis',
  props: ['value'],
  computed: {
    ...mapGetters('customers', {modelValidations: 'validations'}),
    ...mapGetters('project', ['project']),
    nisValidation () {
      return nisService
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/Customer/InputNis.vue